export default __webpack_public_path__ + "static/media/A4UW30GFA2_01_A5UW36GFA2_01.6e5837c2.png";